import { fields } from "@monorepo/utils/src/variables/projectsData/passportArchiveStoreReport/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_ARCHIVE]: {},
});
